<template>
  <div>
    <language-list
      v-show="false"
      v-if="isLang === true"
      v-model="langCurrent"
      :name="`${item.id}${name ? name : ''}`"
    />
    <div class="row">
      <template v-for="(field, key) in fields">
        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-if="
            field.ishide !== true &&
            field.type === 'field' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <fg-input
            :type="field.textType"
            :label="field.keyLang ? field.keyLang : field.label"
            :lang="field.lang"
            :name="field.key"
            v-model="item[field.key]"
            :readonly="field.readonly"
            :placeholder="field.placeholder ? field.placeholder : ''"
            step="1"
          ></fg-input>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'mask' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <fg-input
            type="text"
            :lang="field.lang"
            :name="field.key"
            :label="field.label"
            v-mask="field.mask"
            v-model="item[field.key]"
          />
        </div>
        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'clients' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label v-if="!field.keyLang"
            >{{ field.key | setText(field.label) }}
          </label>
          <label v-else>{{ field.keyLang | setText() }} </label>

          <group-client-list
            :group_id="field.group_id"
            v-model="item[field.key]"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'tag' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label v-if="!field.keyLang"
            >{{ field.key | setText(field.label) }}
          </label>
          <label v-else>{{ field.keyLang | setText() }} </label>

          <tags v-model="item[field.key]" />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'locale' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <locale :title="field.label" v-model="item[field.key]" />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'notifications' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <NotificationSelect :title="field.label" v-model="item[field.key]" :items="field.items"/>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'img' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <img-upload
            :name="field.key"
            v-model="item[field.key]"
            :title="field.label"
            :background="field['secondKey'] ? item[field['secondKey']] : '#fff'"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'imgs' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <images
            :name="field.key"
            v-model="item[field.key]"
            :title="field.label"
            :result="item[field.resultKey]"
            :link="field.link"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'zip' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <zip-upload
            :name="field.key"
            v-model="item[field.key]"
            :title="field.label"
            :result="item[field.resultKey]"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'files' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <files-upload
            :name="field.key"
            v-model="item[field.key]"
            :title="field.label"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'audio' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <audio-upload
            :name="field.key"
            v-model="item[field.key]"
            :title="field.label"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'select' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <selector
            :disabled="field.readonly"
            v-model="item[field.key]"
            :title="field.label"
            :pushLink="field.pushLink"
            :prefix="field.prefix"
            :modal="field.modal"
            :params="field.params"
            :selectKey="field.selectKey"
            @input="conditional"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'course' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label>{{ field.label }}</label>
          <courses v-model="item[field.key]" />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'selects' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <selectors
            :disabled="field.readonly"
            :selectKey="field.selectKey"
            v-model="item[field.key]"
            :title="field.label"
            :pushLink="field.pushLink"
            :modal="field.modal"
            :prefix="field.prefix"
            :params="field.params"
            @input="conditional"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'datetime' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label
            >{{ field.label }}
            <span v-if="field.lang"> ({{ field.lang }}})</span></label
          >
          <datetime
            class="from-control"
            type="datetime"
            v-model="item[field.key]"
            format="dd/MM/yyyy HH:mm:ss"
          >
          </datetime>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'date' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label
            >{{ field.label }}
            <span v-if="field.lang"> ({{ field.lang }}})</span></label
          >
          <datetime
            class="from-control"
            type="date"
            v-model="item[field.key]"
            format="dd.MM.yyyy"
          ></datetime>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'checkbox' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <br />
          <checkbox v-model="item[field.key]" color="#ffc107">
            <label v-if="!field.keyLang"
              >{{ field.key | setText(field.label) }}
            </label>
            <label v-else>{{ field.keyLang | setText() }} </label>
          </checkbox>
          <br />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'static_radio' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <radio-list
            :title="field.label"
            :items="field.items"
            :name="field.key"
            v-model="item[field.key]"
            color="#ffc107"
          >
            <label v-if="!field.keyLang"
              >{{ field.key | setText(field.label) }}
            </label>
            <label v-else>{{ field.keyLang | setText() }} </label>
          </radio-list>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'object' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label v-if="!field.keyLang"
            >{{ field.key | setText(field.label) }}
          </label>
          <label v-else>{{ field.keyLang | setText() }} </label>
          <sub-field-list
            v-model="item[field.key]"
            :subFields="field.subFields"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'location' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <label v-if="!field.keyLang"
            >{{ field.key | setText(field.label) }}
          </label>
          <label v-else>{{ field.keyLang | setText() }} </label>

          <location
            :city="item.location ? item.location.id : null"
            :region="item.location ? item.location.parent_id : null"
            v-model="item[field.key]"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'textarea' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <div class="form-group">
            <label class="control-label">
              <label v-if="!field.keyLang"
                >{{ field.key | setText(field.label) }}
              </label>
              <label v-else>{{ field.keyLang | setText() }} </label>
              <span v-if="field.lang"> ({{ field.lang }})</span></label
            >
            <textarea
              class="form-control"
              :placeholder="field.placeholder"
              v-model="item[field.key]"
            />
          </div>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'excel' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <div class="form-group">
            <label v-if="!field.keyLang"
              >{{ field.key | setText(field.label) }}
            </label>
            <label v-else>{{ field.keyLang | setText() }} </label>
            <excel-reader></excel-reader>
          </div>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="!field.langKey || (field.langKey && langCurrent)"
          v-else-if="
            field.ishide !== true &&
            field.type === 'role' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <div class="form-group">
            <label v-if="!field.keyLang"
              >{{ field.key | setText(field.label) }}
            </label>
            <label v-else>{{ field.keyLang | setText() }} </label>
            <role v-model="item[field.key]" />
          </div>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-else-if="
            field.ishide !== true &&
            field.type === 'html' &&
            field.isMultiLang !== true
          "
          :key="key"
        >
          <div v-show="!field.langKey || (field.langKey && langCurrent)">
            <label class="control-label">
              <label v-if="!field.keyLang"
                >{{ field.key | setText(field.label) }}
              </label>
              <label v-else>{{ field.keyLang | setText() }} </label>
              <span v-if="field.lang"> ({{ field.lang }})</span></label
            >


            <RichEditor v-model="item[field.key]" />
            <br />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
/**Меняю добавление модалку */
import ExcelReader from "@/components/ExcelReader";
import GroupClientList from "../Inputs/GroupClientList.vue";
import RichEditor from "@/components/Editor/RichTextEditor.vue";
import NotificationSelect from "./Notification/NotificationSelect.vue";

export default {
  name: "FieldsList",
  data: () => ({
    langCurrent: "ru",
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "image"], // toggled buttons
          ["blockquote", "code-block"],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
        ],
      },
    },
  }),
  components: {
    RichEditor,
    ExcelReader,
    GroupClientList,
    NotificationSelect
},
  props: ["item", "fields", "name"],
  computed: {
    isLang: {
      get() {
        for (let i = 0; i < this.fields.length; i++) {
          if (this.fields[i].isMultiLang) {
            return true;
          }
        }
        return false;
      },
    },
  },
  created() {
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type === "hidden") {
        this.item[this.fields[i].key] = this.fields[i].value;
      }
    }
  },
  methods: {
    conditional(val) {
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].toParametr) {
          if (
            this.fields[i].toParametr.key &&
            this.fields[i].toParametr.parametr
          ) {
            let key = this.fields[i].toParametr.key;
            let parametr = this.fields[i].toParametr.parametr;
            for (let j = 0; j < this.fields.length; j++) {
              if (this.fields[j].key === key) {
                let value = null;
                if (val && val.id) {
                  value = val.id;
                }
                this.fields[j].params[parametr] = value;
              }
            }
          }
        }
      }

      this.$emit("change", true);
    },
  },
};
</script>

